import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout, MENU } from "@/components/Layout";
import { AuthCallback } from "@/components/AuthCallback";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Inventory from "@/pages/Inventory";
import Transactions from "@/pages/Transactions";
import MasterSpecies from "@/pages/MasterSpecies";
import MasterOrigins from "@/pages/MasterOrigins";
import MasterGrades from "@/pages/MasterGrades";
import Assistant from "@/pages/Assistant";
import StockView from "@/pages/StockView";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";
import Accounting from "@/pages/Accounting";
import Nota from "@/pages/Nota";
import NotaGroup from "@/pages/NotaGroup";
import LabelPrint from "@/pages/LabelPrint";
import ScanOut from "@/pages/ScanOut";
import InstallGuide from "@/pages/InstallGuide";
import Payments from "@/pages/Payments";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import BatchDetail from "@/pages/BatchDetail";
import Settings from "@/pages/Settings";

function Loading() {
  return (
    <div className="min-h-screen aqua-bg flex items-center justify-center" data-testid="auth-loading">
      <div className="h-10 w-10 rounded-full border-4 border-sky-200 border-t-sky-600 animate-spin" />
    </div>
  );
}

function Protected({ children, perm, bare }) {
  const { user, can } = useAuth();
  const loc = useLocation();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname + loc.search }} />;
  const item = MENU.find((m) => m.to === loc.pathname);
  const need = perm || item?.perms;
  if (need && !need.some(can)) {
    const first = MENU.find((m) => m.perms.some(can));
    if (first && first.to !== loc.pathname) return <Navigate to={first.to} replace />;
    if (!first) return <Layout><div className="card-aqua p-8 text-center text-slate-600" data-testid="no-access">Role Anda belum memiliki akses menu apa pun. Hubungi Pemilik.</div></Layout>;
  }
  return bare ? children : <Layout>{children}</Layout>;
}

function LoginRoute() {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <Loading />;
  if (user) return <Navigate to={loc.state?.from || "/"} replace />;
  return <Login />;
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
          <Routes>
            <Route path="/login" element={<LoginRoute />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/pasang" element={<InstallGuide />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/batch/:code" element={<BatchDetail />} />
            <Route path="/settings" element={<Protected><Settings /></Protected>} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/inventory" element={<Protected><Inventory /></Protected>} />
            <Route path="/transactions" element={<Protected><Transactions /></Protected>} />
            <Route path="/scan" element={<Protected><ScanOut /></Protected>} />
            <Route path="/label" element={<Protected bare><LabelPrint /></Protected>} />
            <Route path="/payments" element={<Protected><Payments /></Protected>} />
            <Route path="/master-species" element={<Protected><MasterSpecies /></Protected>} />
            <Route path="/master-origins" element={<Protected><MasterOrigins /></Protected>} />
            <Route path="/master-grades" element={<Protected><MasterGrades /></Protected>} />
            <Route path="/assistant" element={<Protected><Assistant /></Protected>} />
            <Route path="/stock-view" element={<Protected><StockView /></Protected>} />
            <Route path="/reports" element={<Protected><Reports /></Protected>} />
            <Route path="/users" element={<Protected><Users /></Protected>} />
            <Route path="/accounting" element={<Protected><Accounting /></Protected>} />
            <Route path="/nota/:id" element={<Protected bare><Nota /></Protected>} />
            <Route path="/nota-grup/:groupNo" element={<Protected bare><NotaGroup /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
